export enum AutodocType {
	HelpText = 1,
	Description = 2,
	Definition = 3
}

export const AUTODOC_TYPE_LABELS = {
	[ AutodocType.HelpText ]: 'Help Text',
	[ AutodocType.Definition ]: 'Definition',
	[ AutodocType.Description ]: 'Description'
};
